import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRouteIntermediateAccounts = ({
  children,
  tokenKey = "intermediateaccountstoken",
}) => {
  const token = sessionStorage.getItem(tokenKey);
  const className = sessionStorage.getItem("className");
  const location = useLocation();

  const class11Routes = [
    "/intermediate-accounts-dashboard-class-xi",
    "/intermediate-accounts-payment-pending-class-xi",
    "/intermediate-accounts-reject-payment-class-xi",
    "/intermediate-accounts-verified-payment-class-xi",
    "/intermediate-accounts-challan-pending-submission-class-xi",
    "/intermediate-accounts-reports-class-xi",
    "/intermediate-accounts-fees-structure-class-xi",
  ];
  const class12Routes = [
    "/intermediate-accounts-dashboard-class-xii",
    "/intermediate-accounts-payment-pending-class-xii",
    "/intermediate-accounts-reject-payment-class-xii",
    "/intermediate-accounts-verified-payment-class-xii",
    "/intermediate-accounts-challan-pending-submission-class-xii",
    "/intermediate-accounts-reports-class-xii",
    "/intermediate-accounts-fees-structure-class-xii",
  ];


  if (!token) {
    return <Navigate to="/intermediate-accounts" replace />;
  }

  // Class 9 check
  if (
    className === "CLASS_11" &&
    ![...class11Routes].includes(location.pathname)
  ) {
    return <Navigate to="/intermediate-accounts-dashboard-class-xi" />;
  }

  // Class 10 check
  if (
    className === "CLASS_12" &&
    ![...class12Routes].includes(location.pathname)
  ) {
    return <Navigate to="/intermediate-accounts-dashboard-class-xii" />;
  }

  return children;
};

export default PrivateRouteIntermediateAccounts;
